var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"pull-right",staticStyle:{"margin":"20px"},attrs:{"type":"danger","plain":"","round":""},on:{"click":_vm.resetData}},[_vm._v("Initialize Sample Data")])}
var staticRenderFns = []

export { render, staticRenderFns }